import type { AppQueryMeta } from './query-client';

const SIGNED_OUT_SUPPRESS_STATUSES = new Set([401, 403]);

/**
 * Strip auth-loss suppress tags from Clerk-session authed hooks.
 * Global policy covers signed-out 401/403; token-flow keeps them
 * via skipClerkRefresh.
 */
export function sanitizeAuthedQueryMeta(
  meta: AppQueryMeta | undefined
): AppQueryMeta | undefined {
  if (!meta?.suppressSentryStatuses?.length) return meta;
  if (meta.skipClerkRefresh === true) return meta;

  const filtered = meta.suppressSentryStatuses.filter(
    status => !SIGNED_OUT_SUPPRESS_STATUSES.has(status)
  );

  if (filtered.length === meta.suppressSentryStatuses.length) return meta;

  const next: AppQueryMeta = { ...meta };
  if (filtered.length === 0) {
    delete next.suppressSentryStatuses;
  } else {
    next.suppressSentryStatuses = filtered;
  }
  return Object.keys(next).length > 0 ? next : undefined;
}
